import type { IconProps } from '@src/components/icons/IconProps';

export function MoonIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {/* Translated by (0.34, -0.34) from the drawn crescent so the ink is centred
          in the 24x24 box: the shape is unchanged, it just no longer sits low and
          left of centre the way it did, which read as a misaligned icon. */}
      <path d="M20.34 14.16A8.5 8.5 0 0 1 9.84 3.66a8.5 8.5 0 1 0 10.5 10.5Z" />
    </svg>
  );
}
